import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'getLocaldateByTime',
    standalone: false
})
export class GetLocaldateByTimePipe implements PipeTransform {

    transform(time: number): string {
        return new Date(time).toLocaleString("de-DE");
    }

}
